import { render, staticRenderFns } from "./AdminAppPaid2024ShowItem.vue?vue&type=template&id=593827fe&scoped=true"
import script from "./AdminAppPaid2024ShowItem.vue?vue&type=script&lang=js"
export * from "./AdminAppPaid2024ShowItem.vue?vue&type=script&lang=js"
import style0 from "./AdminAppPaid2024ShowItem.vue?vue&type=style&index=0&id=593827fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593827fe",
  null
  
)

export default component.exports